import * as React from 'react';
import {IOption, IOptionGroup} from "../../classes/seating-option";
import { formatId } from '../../helpers/string-format';

interface ICheckbox {
    key: string;
    onChangeFunction: (SeatingOption: IOption) => any;
    checked: boolean;

    option: IOption;
    groupName: string;
}

class Checkbox extends React.PureComponent<ICheckbox, any> {
    private validId = this.props.option.id === "all" ? this.props.option.id : `${formatId(this.props.groupName)}_${this.props.option.id}`;

    render() {
        return (
            <li className="form-item">
                <input type="checkbox" className="checkbox-custom" name={this.props.groupName}
                    value={this.props.checked.toString()} id={this.validId}
                    onChange={ () => { this.props.onChangeFunction(this.props.option) } }
                    checked={ this.props.checked }/>
                <label htmlFor={this.validId}>{this.props.option.name}</label>
            </li>
        );
    }
}

export default Checkbox;